import get from "lodash.get"

// Admin source of truth lives on the User document in Mongo
// (User.isAdmin). Backend returns it on the signin response, so the
// logged-in user's redux blob has it directly.
// Flip it on a user with nodeapi/scripts/setAdmin.js.
export const isAdminUser = state =>
  !!get(state, "user.loaded.user.isAdmin")
